import { useAuth0 } from "@auth0/auth0-react";
import { DefaultButton } from "components/Shared/DefaultButton";
import type React from "react";

export const LogoutButton: React.FC = () => {
  const { logout } = useAuth0();

  return (
    <DefaultButton
      className="ml-15 mb-25"
      onClick={() =>
        logout({
          logoutParams: {
            returnTo: window.location.origin,
          },
        })
      }
      icon={<i style={{ fontSize: "1.5rem" }} className="fa-solid fa-right-from-bracket" />}
      size="large"
      type="text"
    ></DefaultButton>
  );
};
